<template>
    <jet-form-section-alternative @submitted="updatePassword">
        <template #title>
           {{ $t('profile.passwordRefresh') }}
        </template>

        <template #description>
            {{ $t('profile.passwordInfo') }}
        </template>

        <template #form>

            <div v-if="!user.passwordSet" class="rounded-md bg-yellow-50 p-4 mb-4">
                <div class="flex">
                    <div class="flex-shrink-0">
                    <!-- Heroicon name: mini/exclamation-triangle -->
                    <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M8.485 3.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 3.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                    </svg>
                    </div>
                    <div class="ml-3">
                    <h3 class="text-sm font-medium text-yellow-800">{{ $t('auth.noPasswordSet') }}</h3>
                    <div class="mt-2 text-sm text-yellow-700">
                        <p>{{ $t('auth.noPasswordSetDesc') }}</p>
                    </div>
                    </div>
                </div>
            </div>

            <div class="col-span-6 sm:col-span-4">
                <jet-label for="current_password" :value="$t('profile.passwordCurrent')" />
                <jet-input id="current_password" type="password" class="mt-1 block w-full" v-model="form.current_password" ref="current_password" autocomplete="current-password" />
                <jet-input-error :message="form.errors.current_password" class="mt-2" />
            </div>

            <div class="col-span-6 sm:col-span-4 mt-2">
                <jet-label for="password" :value="$t('profile.passwordNew')" />
                <jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" ref="password" autocomplete="new-password" />
                <jet-input-error :message="form.errors.password" class="mt-2" />
            </div>

            <div class="col-span-6 sm:col-span-4 mt-2">
                <jet-label for="password_confirmation" :value="$t('profile.passwordConfirm')" />
                <jet-input id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" autocomplete="new-password" />
                <jet-input-error :message="form.errors.password_confirmation" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <primary-button
                class="mt-2"
                :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{ $t('actions.save') }}
            </primary-button>
        </template>
    </jet-form-section-alternative>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetActionMessage from '@/Jetstream/ActionMessage.vue'
    import PrimaryButton from '@/Jetstream/PrimaryButton.vue'
    import JetFormSectionAlternative from '@/Jetstream/FormSectionAlternative.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import JetLabel from '@/Jetstream/Label.vue'

    export default defineComponent({
        components: {
            JetActionMessage,
            PrimaryButton,
            JetFormSectionAlternative,
            JetInput,
            JetInputError,
            JetLabel,
        },

        props: ["user"],

        data() {
            return {
                form: this.$inertia.form({
                    current_password: '',
                    password: '',
                    password_confirmation: '',
                }),
            }
        },

        methods: {
            updatePassword() {
                this.form.put(this.route('user-password.update'), {
                    errorBag: 'updatePassword',
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$notify({
                            group: "success",
                            title: "actions.success",
                            text: "profile.passwordUpdated"
                        });
                        this.form.reset();
                    },
                    onError: () => {
                        if (this.form.errors.password) {
                            this.form.reset('password', 'password_confirmation')
                            this.$refs.password.focus()
                        }

                        if (this.form.errors.current_password) {
                            this.form.reset('current_password')
                            this.$refs.current_password.focus()
                        }
                    }
                })
            },
        },
    })
</script>
